import { Color, Flex, IconButton, Modal, SectionMessage, Space, Spacing, Text, useModal } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { DepositInvoicesModalImage } from '../../../../../../../../assets/images'
import * as Styled from './styles'

interface CreateDepositInvoiceEntryPointModalBodyProps {
  id: string
}

export const CreateDepositInvoiceEntryPointModalBody = ({
  id,
}: CreateDepositInvoiceEntryPointModalBodyProps): ReactElement => {
  const { t } = useTranslation()
  const { close: handleCloseButtonClick } = useModal(id)

  return (
    <Modal.Body>
      <Styled.CloseButtonRow>
        <IconButton icon="x" onClick={handleCloseButtonClick} />
      </Styled.CloseButtonRow>
      <Flex flexDirection="column" gap={Spacing.S8}>
        <Styled.ModalImageWrapper>
          <DepositInvoicesModalImage />
        </Styled.ModalImageWrapper>
        <Text variant="h3">
          {t('external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.title')}
        </Text>
        <Text variant="bodyLG">
          {t('external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.description')}
        </Text>
        <Space size="s8" />
        <Flex flexDirection="column">
          <Text variant="bodyMD" weight="semiBold">
            {t('external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.steps_heading')}
          </Text>
          <Trans
            i18nKey="external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.steps"
            components={{
              ol: <Styled.CreateDepositInvoiceEntryPointModalSteps />,
              li: <li />,
            }}
          />
        </Flex>
        <Space size="s8" />
        <SectionMessage icon="rocket" showIcon variant="success">
          <Text variant="bodyMD" weight="semiBold" color={Color.Grey800}>
            {t('external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.available_on_plan')}
          </Text>
        </SectionMessage>
        <Text variant="bodySM" colorVariant="discreet">
          {t('external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.coming_soon')}
        </Text>
      </Flex>
    </Modal.Body>
  )
}
